// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chats';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m6.167 13.533-2.267 1.7v-3.4H1.633A1.133 1.133 0 0 1 .5 10.7V1.633A1.133 1.133 0 0 1 1.633.5H14.1a1.133 1.133 0 0 1 1.133 1.133v3.4M3.9 3.9h7.933M3.9 7.3h2.267' />
    <path d='M17.5 14.1h-2.267v3.4l-3.4-3.4h-3.4V7.3H17.5zm-2.267-4.533H10.7m4.533 2.266H10.7' />
  </g>
);

export const viewBox = '0 0 18 18';
